module.exports = __webpack_public_path__ + "static/media/close.8b41ea9b.svg";